// @ts-check
import { AlertTriangle } from 'lucide-react';

/**
 * Centered confirmation modal shown when useUnsavedChangesGuard's blocker has
 * intercepted a navigation attempt. Renders nothing unless blocker.state is
 * 'blocked' — safe to render unconditionally anywhere in a page's JSX.
 *
 * @param {{ blocker: import('react-router-dom').Blocker }} props
 */
const UnsavedChangesPrompt = ({ blocker }) => {
  if (blocker.state !== 'blocked') return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="bg-card rounded-lg shadow-xl max-w-sm w-full p-6">
        <div className="flex items-start gap-3">
          <AlertTriangle size={22} className="text-amber-500 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="text-base font-semibold text-foreground">Unsaved changes</h3>
            <p className="text-sm text-muted-foreground mt-1">
              You have unsaved changes on this page. If you leave now, they'll be lost.
            </p>
          </div>
        </div>
        <div className="mt-5 flex justify-end gap-3">
          <button
            onClick={() => blocker.reset?.()}
            className="px-4 py-2 text-sm font-medium text-foreground/80 hover:text-foreground"
          >
            Stay
          </button>
          <button
            onClick={() => blocker.proceed?.()}
            className="px-4 py-2 text-sm font-medium bg-primary text-primary-foreground rounded-lg hover:bg-primary/90"
          >
            Leave without saving
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesPrompt;
